import { Component, ViewEncapsulation } from '@angular/core';

import { CompanyService }         from '../companies/company.service';
import { IntelligenceRangeModel } from './typings/intelligence.range';
import { IntelligenceService }    from './intelligence.service';
import { SessionService }         from '../sessions/session.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector     : 'wor-intelligence',
  styles: [ require('./intelligence.component.scss') ],
  template: require('./intelligence.component.html')
})
export class IntelligenceComponent {
  activeTab = 'overview';
  entitled = false;

  tabs = [ 'overview', 'money', 'customers', 'vehicles', 'products', 'mechanics', 'operations' ];

  constructor (
    private companyService    : CompanyService,
    public intelligenceService: IntelligenceService,
    private sessionService    : SessionService
  ) {
    this.entitled = this.sessionService.isAdminUser() && this.companyService.hasIntelligence();

    if ( this.companyService.hasDealership() ) {
      this.tabs.push('dealership');
    }
  }

  onRangeChange ( range : IntelligenceRangeModel ) : void {
    this.intelligenceService.setRange(range);
  }

  print () : void {
    window.print();
  }

  selectTab ( tab : string ) : void {
    this.activeTab = tab;
  }
}
